import { PERMISOS } from "@/directives/dbDialogs.js";

/*
 * Secciones del panel. "permiso: null" = visible para cualquier usuario;
 * una lista de permisos = basta con tener uno de ellos.
 * El menú lateral y el dashboard usan esta lista, así que añadir una sección
 * solo exige tocar aquí y registrar su componente en Dashboard.vue.
 * El backend vuelve a comprobar el permiso en cada petición.
 */
export const SECCIONES = [
  { key: "principal", texto: "Resumen", icon: "space_dashboard", grupo: "General", permiso: null },
  { key: "noticias", texto: "Noticias", icon: "newspaper", grupo: "Contenido", permiso: PERMISOS.NOTICIAS },
  { key: "noticiasCaritas", texto: "Noticias Cáritas", icon: "volunteer_activism", grupo: "Contenido", permiso: PERMISOS.CARITAS },
  { key: "galeria", texto: "Galerías", icon: "photo_library", grupo: "Contenido", permiso: PERMISOS.GALERIAS },
  { key: "popUp", texto: "Avisos emergentes", icon: "campaign", grupo: "Contenido", permiso: PERMISOS.POPUPS },
  { key: "avisosMovil", texto: "Avisos al móvil", icon: "notifications_active", grupo: "Contenido", permiso: [PERMISOS.NOTICIAS, PERMISOS.CARITAS, PERMISOS.POPUPS] },
  { key: "urls", texto: "Sitios de interés", icon: "link", grupo: "Contenido", permiso: PERMISOS.ENLACES },
  { key: "horarios", texto: "Horarios", icon: "schedule", grupo: "Parroquia", permiso: PERMISOS.HORARIOS },
  { key: "usuarios", texto: "Usuarios", icon: "group", grupo: "Administración", permiso: PERMISOS.USUARIOS },
  { key: "roles", texto: "Roles y permisos", icon: "admin_panel_settings", grupo: "Administración", permiso: PERMISOS.ROLES },
  { key: "perfil", texto: "Mi perfil", icon: "account_circle", grupo: "Mi cuenta", permiso: null },
];

export function seccionesPermitidas(puede) {
  return SECCIONES.filter((s) => !s.permiso || [].concat(s.permiso).some((p) => puede(p)));
}
